import React from 'react';
import { useTranslation } from 'react-i18next';

class ChartErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean; error?: Error }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch() {
    // Error caught and handled by displaying fallback UI
  }

  render() {
    if (this.state.hasError) {
      return <ChartErrorFallback />;
    }
    return this.props.children;
  }
}

const ChartErrorFallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-full text-gray-500">
      <div className="text-center">
        <div>{t('receiver:chartError.couldNotRender')}</div>
        <div className="text-xs mt-1">{t('receiver:chartError.refreshToRetry')}</div>
      </div>
    </div>
  );
};

export default ChartErrorBoundary;
